var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightUpLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6729 15.6904L12.3286 30.0347L9.97156 27.6777L24.3159 13.3333H11.6729V10H30.0062V28.3333H26.6729V15.6904Z",
    fill: "#0C111D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightUpLine);
export default __webpack_public_path__ + "static/media/arrow-right-up-line.71381a2dea7a85bd0a973f0444d2be29.svg";
export { ForwardRef as ReactComponent };